import { SearchX } from 'lucide-react'
import { Button } from '@/components/ui/button'

/**
 * Estado vazio com saída. "Nenhum resultado encontrado" sozinho deixa o usuário sem
 * saber se a lista está vazia ou se é o filtro que está apertado demais — e sem um
 * caminho de volta que não seja apagar a URL na mão.
 */
export function EmptyResults({
  /** Frase pronta, já concordada: "Nenhuma assinatura encontrada". */
  message,
  term,
  hasFilters,
  onClear,
}: {
  message: string
  term?: string
  hasFilters: boolean
  onClear: () => void
}) {
  return (
    <div className="flex flex-col items-center gap-3 py-12 text-center text-muted-foreground">
      <SearchX className="h-10 w-10 opacity-40" />
      <p className="text-sm">
        {message}
        {term ? (
          <>
            {' '}
            para <strong>&ldquo;{term}&rdquo;</strong>
          </>
        ) : (
          ' com estes filtros'
        )}
      </p>
      {(hasFilters || term) && (
        <Button type="button" variant="outline" size="sm" onClick={onClear}>
          Limpar filtros
        </Button>
      )}
    </div>
  )
}
